import { PublicKey } from '@solana/web3.js';
import BigNumber from 'bignumber.js';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function judgingSize(number: number | string) {
  return BigNumber(number).gt(0);
}

export const genJudgingSizeColor = (value: string | number = 0) => {
  if (value === null || value === undefined || value === '') value = 0;
  const bigValue = new BigNumber(value);
  return bigValue.gt(0) ? 'text-buyColor' : bigValue.lt(0) ? 'text-sellColor' : '';
};

export function judgingSizeToken(value: number | string = 0, minsToken?: true) {
  if (value === undefined || value === null) value = 0;

  return judgingSize(value) ? '+' : minsToken ? '-' : '';
}

// 校验是一个合法的solana地址
export const isValidSolanaAddress = (address: string): boolean => {
  try {
    new PublicKey(address);
    return true;
  } catch (error) {
    return false;
  }
};

// 校验是否是一个合法的evm地址
export const isValidEvmAddress = (address: string): boolean => {
  const evmAddressRegex = /^0x[a-fA-F0-9]{40}$/;
  return evmAddressRegex.test(address);
};

// 获取匹配的标签
export const getMatchedTags = (tagString: string, tagList: { label: string; value: string }[]) => {
  if (!tagString) {
    return [];
  }

  const tagValues = tagString
    .split('|')
    .filter((tag) => tag.trim() !== '')
    .map((tag) => tag.trim());

  return tagList.filter((item) => tagValues.includes(item.value));
};
